import { useState, useEffect } from 'react';
import lightTheme from '../assets/dark.svg';
import darkTheme from '../assets/light.svg';
import logoWhite from '../assets/logoWhite.png';
import logoBlack from '../assets/logoBlack.png';


const Theme = () => {
    const [themeIcon, setThemeIcon] = useState(darkTheme);
    const [iconColor, setIconColor] = useState("ffffff");
    const [ themeLogo, setThemeLogo ] = useState(logoWhite)


    function changeThemeColor(newColor) {
        const metaThemeColor = document.querySelector('meta[name=theme-color]');
        if (metaThemeColor) {
            metaThemeColor.setAttribute('content', newColor);
        }
    }

    const setTheme = (theme) => {
        if (theme === "dark") {
            setThemeIcon(darkTheme)
            setThemeLogo(logoWhite)
            setIconColor("ffffff")
            changeThemeColor("#0a0a0a")
            document.documentElement.classList.add('dark-theme');
        } else {
            setThemeIcon(lightTheme)
            setThemeLogo(logoBlack)
            setIconColor("000000")
            changeThemeColor("#fefefe")
            document.documentElement.classList.remove('dark-theme');
        }
    }
    const toggleTheme = () => {
        let theme = localStorage.getItem("theme");
        if (!theme || theme === "light") {
            setTheme("dark");
            localStorage.setItem("theme", "dark");
        } else {
            setTheme("light");
            localStorage.setItem("theme", "light");
        }
    }



    return { toggleTheme, setTheme, themeIcon, iconColor, themeLogo };
};

export default Theme;
